import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { fetchSends, recordSend, updateSendStatus } from "../services/proposalSendService";

const KEY = "proposal-sends";

/* No stale window: the log is the record of what went out, and a rep looking at
   it right after sending must see their own row. */
export const useProposalSends = (filters = {}) =>
  useQuery({
    queryKey: [KEY, filters],
    queryFn: () => fetchSends(filters),
    staleTime: 0,
    refetchOnMount: "always",
    keepPreviousData: true,
  });

const useSendMutation = (mutationFn, successMessage) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (res) => {
      /* The API distinguishes what actually happened — it mailed the PDF, or it
         only wrote the row — so its sentence is the one shown. */
      const said = res?.message || successMessage;
      if (said) toast.success(said);
      queryClient.invalidateQueries({ queryKey: [KEY], refetchType: "all" });
    },
    onError: (err) => toast.error(err?.message || "Something went wrong"),
  });
};

export const useRecordSend = () =>
  useSendMutation((payload) => recordSend(payload), "Recorded in the send log");

export const useUpdateSendStatus = () =>
  useSendMutation(({ id, status }) => updateSendStatus(id, status), "Status updated");
